module.exports = __webpack_public_path__ + "pc/img/ico-anniv.3388d609.svg";